export const BFF_API_PATH = `/experience-bff-service/api`
export const BFF_V1 = `${BFF_API_PATH}/web/v1`
export const BFF_V2 = `${BFF_API_PATH}/web/v2`
export const BFF_LEGACY_V1 = `${BFF_API_PATH}/legacy/web/v1`

export const CREDIT_NEGOTIATIONS_V1 = `/credit-negotiations-service/api/v1`
export const CONTRACTS_SERVICE_V1 = `/contracts-service/api/v1`
